const formatEmoji = { //
  bind(el) {
    if ($) {
      $(el).parseEmotion()
    }
  },
  // 当传进来的值更新的时候触发
  componentUpdated(el) {
    $(el).parseEmotion()
  },
  // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    if ($) {
      $(el).parseEmotion()
    }
  },
};

export default formatEmoji;